/* 🤖 this file was generated by svg-to-ts */
export const emperorIconOperatorMale: {
  name: 'operator_male';
  data: string;
} = {
  name: 'operator_male',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M12 15c-2.76 0-5-2.25-5-5 0-2.76 2.24-5 5-5 2.75 0 5 2.24 5 5h-2c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3v2Z"/><path d="M16 15h-3v-4h4v1.82c1.16-.42 2-1.53 2-2.83v-2h2v2c0 2.75-2.25 5-5 5Z"/><path d="M20 24H4v-2c0-3.54 3.29-6 8-6s8 2.46 8 6v2ZM6 22h12c0-2.36-2.47-4-6-4 -3.54 0-6 1.64-6 4Z"/></g></svg>`,
};
